import { Analytics } from 'analytics';
import { analyticsPlugin } from 'components/actors/analytics';
import { datadogLogs } from '@datadog/browser-logs';
import { Env } from 'internalLibrary';
import initDatadogLogs from 'datadog/logs';

const isEventCollectorEnabled =
  process.env.REACT_APP_EVENT_COLLECTOR_ENABLED === 'true' && !window.Cypress;

if (process.env.REACT_APP_ENV && process.env.REACT_APP_ENV === 'production') {
  // initDatadogRUM(); // Don't  uncomment this unless asked by business. It costs a lot.
  initDatadogLogs();
}

const analyticsInstance = Analytics({
  app: 'registration.vivus.se',
  plugins: [
    ...(isEventCollectorEnabled
      ? [
          analyticsPlugin({
            url: process.env.REACT_APP_ANALYTICS_API as string,
            app: {
              applicationType: 'new',
              env: process.env.REACT_APP_ENV as Env,
              type: 'web',
              version: '1.0.0',
            },
            dequeueInterval: 1000,
            onFetchError: (err) => {
              datadogLogs.logger.error(
                `Analytics event failed to fetch: ${JSON.stringify(
                  err,
                  null,
                  2,
                )}`,
              );
            },
          }),
        ]
      : []),
  ],
});

export default analyticsInstance;
